import React, { Component } from 'react';
import axios from 'axios';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import classes from './GroupManagement.module.css';
// import PersonRounded from '@material-ui/icons/PersonRounded';
import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import apiUrl from "../../../shared/config";
// import {Button} from "@material-ui/core";
// import draftIcon from "../../../assets/images/draft_icon.png";
// import reviewIcon from "../../../assets/images/review_icon.png";
// import publishedIcon from "../../../assets/images/published_icon.png";
// import rejectedIcon from "../../../assets/images/rejected_icon.png";
// import mergedIcon from "../../../assets/images/merged_icon.png";
// import disabledIcon from "../../../assets/images/disabled_icon.png";
// import DropdownButton from "react-bootstrap/DropdownButton";
// import ButtonGroup from "react-bootstrap/ButtonGroup";
// import Dropdown from "react-bootstrap/Dropdown";
// import infoIcon from "../../../assets/images/info.png";


class GroupManagement extends Component {
    _isMounted = false;


    state = {
            group_members: [
                {
                    user_id: null,
                    group_manager: 0,
                    display_name: ''
                }
            ]
    };

    componentDidMount() {
        this._isMounted = true;
        this.getGroupMembersById();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    getGroupMembersById() {
        if (this.props.account_id ) {
            axios.get(apiUrl +'Groups/getGroupMembersByGroupId?group_id=' + this.props.group_id)
                .then(response => {
                    if (this._isMounted) {
                        this.setState({group_members: response.data});
                    }
                });
        }
        else if (this.state.group_members && this.props.account_id === null) {
            if (this._isMounted) {
                this.setState({
                    "group_members": []
                });
            }
        }
    }

    setGroupStatusHandler = (group_id, user_id, group_user_status) => {
        const post = {
            "token": this.props.token,
            "user_id": user_id,
            "group_id": group_id,
            "group_user_status": group_user_status
        };
        axios.post(apiUrl +'Groups/setGroupMemberStatus', post)
            .then(response => {
                this.getGroupMembersById();
            });

    };

    toggleGroupManagerHandler = (group_id, user_id, group_manager) => {
        const post = {
            "token": this.props.token,
            "user_id": user_id,
            "group_id": group_id,
            "group_manager": (group_manager ? 0 : 1)
        };
        axios.post(apiUrl +'Groups/setGroupManagerStatus', post)
            .then(response => {
                this.getGroupMembersById();
            });

    };

    render() {

        const group_members_jsx = this.state.group_members.map( (member, index) => {
            const new_status = (member.group_user_status === 'Active' ? 'Inactive' : 'Active');
            const manager_title = (member.group_manager === 1 ? 'Group Manager' : 'Member');
            const status_id = 'status_'+ member.user_id;
            const manager_id = 'manager_'+ member.user_id;

            const group_member_jsx = (
                <div key={index + "_group_member" + member.user_id}>

                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        rootClose
                        rootCloseEvent="click"
                        key={manager_id}
                        placement='top'
                        overlay={
                            <Popover id='manager_status'>
                                <Popover.Title as="h3">{manager_title}</Popover.Title>
                                <Popover.Content className="pattern-exercise-description">Click on the star to toggle the group manager roll for this group member.</Popover.Content>
                            </Popover>
                        }
                    >
                        <span onClick={() => this.toggleGroupManagerHandler(this.props.group_id, member.user_id, member.group_manager) }>{(member.group_manager ? (<Star/>) : (<StarBorder/>))}</span>
                    </OverlayTrigger>

                    <OverlayTrigger
                        trigger={['hover', 'focus']}
                        rootClose
                        rootCloseEvent="click"
                        key={status_id}
                        placement='top'
                        overlay={
                            <Popover id='member_status'>
                                <Popover.Title as="h3">Group Member Status: {member.group_user_status}</Popover.Title>
                                <Popover.Content className="pattern-exercise-description">Click on this user's name to change their status to {member.group_user_status === 'Active' ? 'Inactive' : 'Active'}</Popover.Content>
                            </Popover>
                        }
                    >
                        <span className={ member.group_user_status === 'Active' ? classes.Active : member.group_user_status === 'Inactive' ? classes.Inactive : classes.Pending
                        } onClick={() => this.setGroupStatusHandler(this.props.group_id, member.user_id, new_status) }>{member.first_name} {member.last_name}</span>
                    </OverlayTrigger>



                </div>
            );
            //

            return group_member_jsx;
        });

        return (
            <div className={classes.GroupMembers}>
                {group_members_jsx}
            </div>
        );
    }
}

export default GroupManagement;